"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIELD_AUTO_GENERATORS = void 0;
var tour_1 = require("./tour");
exports.FIELD_AUTO_GENERATORS = {
    'scheduleATourUrl': {
        fieldName: 'scheduleATourUrl',
        isAvailableToUser: tour_1.canGenerateTourLink,
        valueGenerator: tour_1.generateTourLink,
        templateValuePlaceholder: 'Schedule A Tour URL will be generated by Nurture Boss',
    },
};
